import * as React from 'react';
import { Theme, WithStyles } from '@material-ui/core';
import { mockTheme } from '../../utils/utils';
import withStyles from '@material-ui/core/styles/withStyles';
import { JSONSchema6 } from 'json-schema';
import { AddRaceDTO, RaceType } from '../../api/model';
import { addDays, setMilliseconds } from 'date-fns';
import { ConfigData } from '../../config';
import { getApi } from '../../api/ApiProvider';
import PlanificacionSelector, { RouteData } from './planificacionSelector';
import { BranchActions } from '../../store/branch';
import { DriverActions } from '../../store/driver';



const styles = (theme: Theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing.unit,
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },

    buttons: {
        textAlign: 'right'
    },

    success: {
        textAlign: 'center',
    },
    cardMedia: {
        width: 400,
        height: 400,
        minHeight: 400,
        margin: 'auto',
    }
});


/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

export interface RaceData {
    raceType: RaceType;
    observation?: string;
    withMoney: boolean;
    driver: number | null;
    amount?: number;
    dueDate?: string;
    user: { name: string, document: string, phone?: string, email?: string };
    origin: { street1: string, street2?: string, number?: number, observation?: string },
    destiny: { street1: string, street2?: string, number?: number, observation?: string },
}

export type RaceAbmState = 'edit' | 'adding' | 'added' | 'error';

interface PlanificacionAddProps extends WithStyles<keyof typeof classesType> {
    user?: any; // Información del usuario logueado
    branchActions: BranchActions;
    driverActions: { actions: DriverActions; notification: any };
    state: RaceAbmState;
    config: ConfigData;
    error?: any;
    notification?: any;
    handleAdd(data: AddRaceDTO): void;
}

interface PlanificacionAddState {
    steps: string[];
    activeStep: number;
    data: RaceData;
    routeData?: RouteData;
    schema: JSONSchema6 | null;
    // Campos para progreso de creación de sucursales
    isCreatingBranches: boolean;
    branchesCreated: number;
    totalBranchesToCreate: number;
    currentBatch: number;
    totalBatches: number;
    isCancellingBranches: boolean;
    retryAttempts: number;
    maxRetries: number;
    creationSummary: { success: number; errors: number; retries: number } | null;
    // Campos para progreso de creación de choferes
    isCreatingDrivers: boolean;
    driversCreated: number;
    totalDriversToCreate: number;
    currentDriverBatch: number;
    totalDriverBatches: number;
}

class PlanificacionAdd extends React.Component<PlanificacionAddProps, PlanificacionAddState> {


    static getDefaultData(): RaceData {
        return {

            raceType: 'DELIVERY',
            observation: '',
            withMoney: false,
            dueDate: addDays(setMilliseconds(new Date(), 0), 1).toISOString(),
            user: {
                name: '',
                document: ''
            },
            driver: 0,
            origin: { street1: '' },
            destiny: { street1: '' }
        }
    }

    constructor(props: PlanificacionAddProps) {
        super(props);

        const steps = ['Asignar Ruta', 'Agregar detalles', 'Ver resumen'];
        const state: PlanificacionAddState = {
            steps,
            data: PlanificacionAdd.getDefaultData(),
            activeStep: 0,
            schema: null,
            isCreatingBranches: false,
            branchesCreated: 0,
            totalBranchesToCreate: 0,
            currentBatch: 0,
            totalBatches: 0,
            isCancellingBranches: false,
            retryAttempts: 0,
            maxRetries: 3,
            creationSummary: null,
            // Campos para progreso de creación de choferes
            isCreatingDrivers: false,
            driversCreated: 0,
            totalDriversToCreate: 0,
            currentDriverBatch: 0,
            totalDriverBatches: 0,
        };
        if (props.config.races.predefinedFrom) {
            state.routeData = {
                origin: props.config.maps.startingLocation
            }
        }

        this.state = state;
        this.handleNew = this.handleNew.bind(this);
        this.handleRouteSelection = this.handleRouteSelection.bind(this);



        Promise.all([
            getApi().driver().listActiveByAdmin(),
            getApi().branch().listAllBranchesAdmin()

        ]).then(([drivers, branches]) => {

            console.log("Drivers and branches loaded", drivers, branches);

            this.setState({
                routeData: {
                    ...this.state.routeData,
                    branchList: branches,
                    drivers: drivers
                }
            });
        }).catch(error => {
            console.error("Error fetching data:", error);
        });
    }

    // Método para refrescar la lista de drivers
    refreshDrivers = async () => {
        try {
            const drivers = await getApi().driver().listActiveByAdmin();
            this.setState({
                routeData: {
                    ...this.state.routeData,
                    drivers: drivers
                }
            });
            console.log('Lista de drivers refrescada en PlanificacionAdd');
        } catch (error) {
            console.error('Error refrescando drivers:', error);
        }
    };

    handleData = (data: any) => {
        this.props.handleAdd(data);
    };

    handleCreateBranches = async (branchPayloads: any[]) => {
        // Obtener la compañía del usuario logueado
        let companyId: number | undefined;

        if (this.props.user) {
            // Buscar la compañía siguiendo la ruta correcta: user->company->branch->company->id
            companyId = this.props.user.company &&
                       this.props.user.company.branch &&
                       this.props.user.company.branch.company &&
                       this.props.user.company.branch.company.id;

            if (companyId) {
                console.log('Usando compañía del usuario logueado (user->company->branch->company->id):', companyId);
            } else {
                console.warn('Usuario logueado encontrado pero sin información de compañía en user.company.branch.company.id:', this.props.user);
            }
        }

        if (!companyId) {
            // Fallback: obtener la primera empresa disponible (comportamiento anterior)
            const companies = await getApi().company().list();
            if (!companies || companies.length === 0) {
                throw new Error('No hay empresas disponibles');
            }
            companyId = companies[0].id;
            console.warn('No se encontró compañía en el usuario logueado. Usando la primera empresa disponible:', companies[0].name);
        }

        // Asegurar que companyId tenga un valor válido
        if (!companyId) {
            throw new Error('No se pudo determinar la compañía para crear las sucursales');
        }

        // TypeScript assertion: companyId is guaranteed to be number after the check above
        const guaranteedCompanyId: number = companyId;


        // Configuración de lotes y reintentos
        const BATCH_SIZE = 10; // Procesar 10 sucursales por lote
        const DELAY_MS = 1000; // 1 segundo entre lotes
        const MAX_RETRIES = 3; // Máximo número de reintentos por sucursal

        // Inicializar estado de progreso
        this.setState({
            isCreatingBranches: true,
            branchesCreated: 0,
            totalBranchesToCreate: branchPayloads.length,
            currentBatch: 0,
            totalBatches: Math.ceil(branchPayloads.length / BATCH_SIZE)
        });

        let successCount = 0;
        let errorCount = 0;
        let retryCount = 0;

        console.log(`Iniciando creación de ${branchPayloads.length} sucursales en ${this.state.totalBatches} lotes`);

        try {
            // Procesar por lotes
            for (let i = 0; i < branchPayloads.length; i += BATCH_SIZE) {
                // Verificar si el proceso fue cancelado
                if (this.state.isCancellingBranches) {
                    console.log('Proceso de creación de sucursales cancelado por el usuario');
                    break;
                }

                const batch = branchPayloads.slice(i, i + BATCH_SIZE);
                const batchNumber = Math.floor(i / BATCH_SIZE) + 1;

                // Actualizar lote actual
                this.setState({ currentBatch: batchNumber });

                console.log(`Procesando lote ${batchNumber}/${this.state.totalBatches} (${batch.length} sucursales)`);

                try {
                    // Procesar lote actual con reintentos
                    const batchResults = await Promise.all(batch.map(async (payload) => {
                        return this.createBranchWithRetry(payload, guaranteedCompanyId, MAX_RETRIES);
                    }));

                    // Contar resultados
                    batchResults.forEach(result => {
                        if (result.success) {
                            successCount++;
                        } else {
                            errorCount++;
                        }
                        retryCount += result.retries;
                    });

                    // Actualizar progreso
                    this.setState({ branchesCreated: successCount });

                    const progressPercent = Math.round((successCount / branchPayloads.length) * 100);
                    console.log(`Lote ${batchNumber} completado. Progreso: ${successCount}/${branchPayloads.length} (${progressPercent}%)`);

                    // Pausa entre lotes (excepto el último)
                    if (i + BATCH_SIZE < branchPayloads.length && !this.state.isCancellingBranches) {
                        await new Promise(resolve => setTimeout(resolve, DELAY_MS));
                    }

                } catch (batchError) {
                    console.error(`Error en lote ${batchNumber}:`, batchError);
                    errorCount += batch.length;
                }
            }

            // Crear resumen final
            const summary = {
                success: successCount,
                errors: errorCount,
                retries: retryCount
            };

            console.log(`Creación completada. Resumen:`, summary);

            // Mostrar resumen final
            if (this.props.notification && this.props.notification.notification) {
                const notification = this.props.notification.notification;
                if (errorCount === 0) {
                    notification.addSuccess(
                        'Proceso completado exitosamente',
                        `${successCount} sucursales procesadas: ${successCount} exitosas, ${errorCount} errores${retryCount > 0 ? `, ${retryCount} reintentos` : ''}`
                    );
                } else {
                    notification.addWarning(
                        'Proceso completado con errores',
                        `${branchPayloads.length} sucursales procesadas: ${successCount} exitosas, ${errorCount} errores${retryCount > 0 ? `, ${retryCount} reintentos` : ''}`
                    );
                }
            }

            // Después de crear las sucursales, refrescar la lista de branches
            console.log('Refrescando lista de sucursales después de creación...');
            const updatedBranches = await getApi().branch().listAllBranchesAdmin();

            // Actualizar el estado con las sucursales actualizadas
            this.setState({
                routeData: {
                    ...this.state.routeData,
                    branchList: updatedBranches
                }
            });

            console.log('Lista de sucursales actualizada con', updatedBranches.length, 'sucursales');

        } catch (error) {
            console.error('Error general en la creación de sucursales:', error);
            if (this.props.notification && this.props.notification.notification && this.props.notification.notification.addError) {
                this.props.notification.notification.addError(
                    'Error en el proceso de creación',
                    'Ocurrió un error inesperado durante la creación de sucursales'
                );
            }
            throw error;
        } finally {
            // Limpiar estado de progreso
            this.setState({
                isCreatingBranches: false,
                branchesCreated: 0,
                totalBranchesToCreate: 0,
                currentBatch: 0,
                totalBatches: 0,
                isCancellingBranches: false
            });
        }
    };

    // Método auxiliar para crear una sucursal con reintentos
    createBranchWithRetry = async (payload: any, companyId: number, maxRetries: number) => {
        let lastError: any = null;

        for (let attempt = 0; attempt <= maxRetries; attempt++) {
            try {
                const fullPayload = {
                    ...payload,
                    companyId: companyId
                };

                await getApi().branch().add(fullPayload);
                return { success: true, retries: attempt };
            } catch (error) {
                lastError = error;
                console.warn(`Intento ${attempt + 1}/${maxRetries + 1} falló para sucursal ${payload.name}:`, error);

                // Si no es el último intento, esperar antes de reintentar
                if (attempt < maxRetries) {
                    await new Promise(resolve => setTimeout(resolve, 1000 * (attempt + 1))); // Espera exponencial
                }
            }
        }

        console.error(`Error definitivo creando sucursal ${payload.name} después de ${maxRetries + 1} intentos:`, lastError);
        return { success: false, retries: maxRetries };
    };

    handleNew() {
        this.setState({
            activeStep: 0,
            data: PlanificacionAdd.getDefaultData(),
            routeData: undefined
        });
    }

    handleRouteSelection(data: RouteData) {
        this.setState({
            routeData: data
        })
    }

    // Método para cancelar la creación de sucursales
    cancelBranchCreation = () => {
        console.log('Cancelando creación de sucursales...');
        this.setState({ isCancellingBranches: true });
    };

    handleCreateDrivers = async (driverPayloads: any[]) => {
        // Configuración de lotes
        const BATCH_SIZE = 10; // Procesar 10 choferes por lote
        const DELAY_MS = 1000; // 1 segundo entre lotes

        // Inicializar estado de progreso
        this.setState({
            isCreatingDrivers: true,
            driversCreated: 0,
            totalDriversToCreate: driverPayloads.length,
            currentDriverBatch: 0,
            totalDriverBatches: Math.ceil(driverPayloads.length / BATCH_SIZE)
        });

        let successCount = 0;
        let errorCount = 0;

        console.log(`Iniciando creación de ${driverPayloads.length} choferes en ${this.state.totalDriverBatches} lotes`);

        try {
            // Procesar por lotes
            for (let i = 0; i < driverPayloads.length; i += BATCH_SIZE) {
                const batch = driverPayloads.slice(i, i + BATCH_SIZE);
                const batchNumber = Math.floor(i / BATCH_SIZE) + 1;

                // Actualizar lote actual
                this.setState({ currentDriverBatch: batchNumber });

                console.log(`Procesando lote ${batchNumber}/${this.state.totalDriverBatches} (${batch.length} choferes)`);

                try {
                    // Procesar lote actual en paralelo
                    await Promise.all(batch.map(async (payload) => {
                        try {
                            await this.props.driverActions.actions.save(payload);
                            successCount++;
                        } catch (error) {
                            errorCount++;
                            console.error(`Error creando chofer ${payload.user.name}:`, error);
                        }
                    }));

                    // Actualizar progreso
                    this.setState({ driversCreated: successCount });

                    console.log(`Lote ${batchNumber} completado. Progreso: ${successCount}/${driverPayloads.length}`);

                    // Pausa entre lotes (excepto el último)
                    if (i + BATCH_SIZE < driverPayloads.length) {
                        await new Promise(resolve => setTimeout(resolve, DELAY_MS));
                    }

                } catch (batchError) {
                    console.error(`Error en lote ${batchNumber}:`, batchError);
                    errorCount += batch.length - (successCount - (batchNumber - 1) * BATCH_SIZE);
                }
            }

            console.log(`Creación completada. Éxitos: ${successCount}, Errores: ${errorCount}`);

            // Después de crear los choferes, refrescar la lista de drivers
            console.log('Refrescando lista de choferes después de creación...');
            this.props.driverActions.actions.fetch();

            console.log('Lista de choferes actualizada');

        } catch (error) {
            console.error('Error general en la creación de choferes:', error);
            throw error;
        } finally {
            // Limpiar estado de progreso
            this.setState({
                isCreatingDrivers: false,
                driversCreated: 0,
                totalDriversToCreate: 0,
                currentDriverBatch: 0,
                totalDriverBatches: 0
            });
        }

        // Refrescar la lista de drivers después de crear
        await this.refreshDrivers();
    };

    render() {

        return (
            <PlanificacionSelector
                data={this.state.routeData}
                config={this.props.config}
                onNewData={this.handleRouteSelection}
                sendData={this.handleData}
                notification={this.props.notification}
                onCreateBranches={this.handleCreateBranches}
                onCreateDrivers={this.handleCreateDrivers}
                onCancelBranchCreation={this.cancelBranchCreation}
                driverActions={this.props.driverActions}
            />
        );
    }
}


export default withStyles(styles as any)(PlanificacionAdd);



// WEBPACK FOOTER //
// ./src/components/planificacion/planificacionAdd.tsx